import { render, staticRenderFns } from "./newDesc.vue?vue&type=template&id=6ee24779&scoped=true"
import script from "./newDesc.vue?vue&type=script&lang=js"
export * from "./newDesc.vue?vue&type=script&lang=js"
import style0 from "./newDesc.vue?vue&type=style&index=0&id=6ee24779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee24779",
  null
  
)

export default component.exports